// extracted by mini-css-extract-plugin
export default {"ldsSpinner":"Loading_ldsSpinner__B2l1-"};